export default "__VITE_ASSET__CDocM4kg__"